import { apiService } from '../services/apiService';

export async function loadPlanImageElement(plan) {
  const blobUrl = await apiService.fetchPlanFileBlob(plan);

  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve({ img, blobUrl });
    img.onerror = () => {
      URL.revokeObjectURL(blobUrl);
      reject(new Error('Impossible de charger l\'image du plan'));
    };
    img.src = blobUrl;
  });
}
